import type { SVGProps, ComponentType } from "react";
import {
  ThisMonthIcon,
  SpendingIcon,
  RecurringIcon,
  PaymentPlansIcon,
  BreakdownIcon,
  SettingsIcon,
  PiggyIcon,
  MyPositionIcon,
  BudgetIcon,
  ActivityIcon,
  PlanAheadIcon,
} from "../components/icons";

export interface NavItem {
  to: string;
  label: string;
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
  end: boolean;
  /** true = kept out of the mobile bottom bar; lives in the profile menu instead. */
  secondary: boolean;
}

// Single source of truth for navigation. The desktop rail shows everything; the
// mobile bottom bar shows the primary items, and the profile menu shows the
// secondary ones. Keep the bottom bar to ~5 items — mark extras `secondary`.
// Order = desktop rail order. Primary items (secondary:false) also form the
// mobile bottom bar (keep to ~5); secondary items live in the mobile profile
// menu. Plan Ahead is hidden for now (Savings goals replaced it) — restore it
// by adding it back here.
export const NAV: NavItem[] = [
  { to: "/", label: "This Month", Icon: ThisMonthIcon, end: true, secondary: false },
  { to: "/me", label: "My Position", Icon: MyPositionIcon, end: false, secondary: true },
  { to: "/spending", label: "Spending", Icon: SpendingIcon, end: false, secondary: false },
  { to: "/breakdown", label: "Breakdown", Icon: BreakdownIcon, end: false, secondary: false },
  { to: "/budget", label: "Budget", Icon: BudgetIcon, end: false, secondary: true },
  { to: "/savings", label: "Savings", Icon: PiggyIcon, end: false, secondary: false },
  { to: "/recurring", label: "Recurring", Icon: RecurringIcon, end: false, secondary: false },
  { to: "/plans", label: "Payment Plans", Icon: PaymentPlansIcon, end: false, secondary: true },
  { to: "/estimator", label: "Estimator", Icon: PlanAheadIcon, end: false, secondary: true },
  { to: "/activity", label: "Activity log", Icon: ActivityIcon, end: false, secondary: true },
  { to: "/settings", label: "Settings", Icon: SettingsIcon, end: false, secondary: true },
];
